import { schema } from 'normalizr';

export const milestoneSchema = new schema.Entity('milestone');
